import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=67f1dbce&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=ts"
export * from "./AgentList.vue?vue&type=script&lang=ts"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=67f1dbce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1dbce",
  null
  
)

export default component.exports